import {ActionTree} from "vuex";
import {ProviderConnectionState} from "@/store/settings/provider_connections/types";
import {RootState} from "@/store/types";
import axios from "axios";

export const actions: ActionTree<ProviderConnectionState, RootState> = {
  getProviderConnections: ({commit}, data) => {
    return new Promise((resolve, reject) => {
      axios({url: '/acapi/service_providers/connections', params: data})
        .then(resp => {
          commit('setProviderConnections', resp.data.connections);
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  }
}